export const isEurope = process.env.REACT_APP_RAEGAN === 'EU'